/**
 * 404 Not Found Page
 */

import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="container-custom text-center">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-9xl font-black text-rs-orange mb-4">404</h1>
          <h2 className="text-4xl font-bold mb-6">
            ページが見つかりません
          </h2>
          <p className="text-gray-600 text-lg mb-12">
            お探しのページは存在しないか、移動した可能性があります。
          </p>
          <Link to="/" className="btn-primary">
            トップページへ戻る
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
